// pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const NotFound = () => {
  const { currentUser } = useAuth();
  
  return (
    <div className="error-page d-flex align-items-center min-vh-100">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <div className="text-center">
              <div className="error-code mb-4">
                <h1 style={{ 
                  fontSize: '120px', 
                  fontWeight: 'bold', 
                  margin: 0,
                  background: 'linear-gradient(135deg, #00CC5C 0%, #006E32 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  textShadow: '3px 3px 6px rgba(0, 204, 92, 0.2)'
                }}>
                  404
                </h1>
              </div>
              
              <div className="error-emoji mb-4">
                <span role="img" aria-label="confused face" style={{ fontSize: '72px' }}>
                  🤔
                </span>
              </div>
              
              <div className="error-content mb-5">
                <h2 className="mb-3 text-black">Oops! Page Not Found</h2>
                <p className="lead text-muted">
                  The page you're looking for seems to have gone missing or never existed.
                </p>
                <p className="text-muted">
                  It might have been moved, deleted, or perhaps you entered an incorrect URL.
                </p>
              </div>
              
              <div className="error-actions d-flex flex-column flex-sm-row justify-content-center">
                <Button
                  as={Link}
                  to={currentUser ? "/dashboard" : "/"}
                  variant="success"
                  size="lg"
                  className="mb-3 mb-sm-0 mr-sm-3"
                  style={{ 
                    backgroundColor: '#00CC5C',
                    borderColor: '#00CC5C',
                    boxShadow: '0 4px 6px rgba(0, 204, 92, 0.2)'
                  }}
                >
                  <i className="fas fa-home mr-2"></i>
                  {currentUser ? "Go to Dashboard" : "Go Home"}
                </Button>
                
                <Button
                  as={Link}
                  to="/contact-us"
                  variant="outline-secondary"
                  size="lg"
                  className="ml-sm-3"
                >
                  <i className="fas fa-envelope mr-2"></i>
                  Contact Support
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        
        <Row className="mt-5">
          <Col className="text-center">
            <div className="error-suggestions">
              <h5 className="mb-3">You might want to try:</h5>
              <ul className="list-unstyled">
                <li><i className="fas fa-check-circle text-success mr-2"></i> Checking the URL for typos</li>
                <li><i className="fas fa-check-circle text-success mr-2"></i> Going back to the previous page</li>
                <li><i className="fas fa-check-circle text-success mr-2"></i> Using the navigation menu</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
      
      {/* Animated background elements */}
      <div className="position-absolute" style={{ zIndex: -1, width: '100%', height: '100%', overflow: 'hidden', top: 0, left: 0 }}>
        {[...Array(6)].map((_, i) => (
          <div 
            key={i}
            className="position-absolute"
            style={{
              width: 20 + Math.random() * 30 + 'px',
              height: 20 + Math.random() * 30 + 'px',
              borderRadius: '50%',
              background: `rgba(0, 204, 92, ${0.05 + Math.random() * 0.05})`,
              left: Math.random() * 100 + '%',
              top: Math.random() * 100 + '%',
              animation: `float ${5 + Math.random() * 10}s ease-in-out infinite`,
              animationDelay: `${Math.random() * 5}s`
            }}
          />
        ))}
      </div>
      
      {/* Custom Animation CSS */}
      <style jsx>{`
        @keyframes float {
          0% {
            transform: translateY(0) translateX(0);
          }
          50% {
            transform: translateY(-20px) translateX(10px);
          }
          100% {
            transform: translateY(0) translateX(0);
          }
        }
        
        .error-page {
          background-color: #f8f9fa;
          position: relative;
        }
        
        .error-suggestions ul li {
          margin-bottom: 8px;
          font-size: 16px;
          color: #6c757d;
        }
      `}</style>
    </div>
  );
};

export default NotFound;